import { parseEntityItemId } from '@wix/a11y-rules';
import { assertNotOptional } from '@wix/seo-common-core';
import _ from 'lodash';
import { modify } from 'ricos-content/libs/modify';
import { buildSingleNode } from '../../utils/build-single-rich-content-node';
export let GroupImageType = /*#__PURE__*/function (GroupImageType) {
  GroupImageType["MAIN_IMAGE"] = "MAIN_IMAGE";
  GroupImageType["DESCRIPTION"] = "DESCRIPTION";
  return GroupImageType;
}({});
const updateRichContent = (group, updatesForGroup) => {
  var _description$nodes;
  const description = JSON.parse(group.description ?? '{}');
  const updatesByNodeId = _.groupBy(updatesForGroup, upd => upd.nodeId);
  if (!(description != null && (_description$nodes = description.nodes) != null && _description$nodes.length)) {
    return null;
  }
  return modify(description).filter(node => Object.keys(updatesByNodeId).includes(node.id)).set(node => buildSingleNode(node, updatesByNodeId[node.id]));
};
export const buildGroupsBulkUpdatePayload = (altTextData, groupsMap) => {
  const payload = [];
  const updatesByGroupId = _.groupBy(altTextData.map(_ref => {
    let {
      id,
      alt,
      entityId
    } = _ref;
    const group = groupsMap.get(entityId ?? '');
    const {
      itemId: imageId,
      entities
    } = parseEntityItemId(id, 2);
    assertNotOptional(group);
    const groupId = group.id;
    const imageType = imageId.includes('cover') ? GroupImageType.MAIN_IMAGE : GroupImageType.DESCRIPTION;
    if (imageType === GroupImageType.MAIN_IMAGE) {
      return {
        alt,
        entityId: groupId,
        imageId: id,
        isMain: true
      };
    }
    return {
      alt,
      entityId: groupId,
      imageId,
      isMain: false,
      nodeId: entities.length > 1 ? entities[1] : ''
    };
  }), upd => upd.entityId);
  Object.entries(updatesByGroupId).forEach(_ref2 => {
    let [groupId, updatesForGroup] = _ref2;
    if (!groupId) {
      return;
    }
    const originalGroup = groupsMap.get(groupId);
    if (!originalGroup) {
      return;
    }
    const updatedGroup = {
      id: groupId
    };
    const descriptionToUpdate = updateRichContent(originalGroup, updatesForGroup.filter(upd => !upd.isMain));
    if (descriptionToUpdate) {
      updatedGroup.description = JSON.stringify(descriptionToUpdate);
    }
    const mainImageToUpdate = updatesForGroup.find(upd => upd.isMain);
    if (mainImageToUpdate) {
      updatedGroup.coverImage = {
        ...originalGroup.coverImage,
        altText: mainImageToUpdate.alt
      };
    }
    payload == null || payload.push(updatedGroup);
  });
  return payload;
};
//# sourceMappingURL=bulk-update-groups-alt-text-payload-builder.js.map